import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';
import React, { useMemo } from 'react'
import { Badge, Table } from 'react-bootstrap';
import { FaEdit, FaTimes } from 'react-icons/fa';

const ReportsTable = ({ reports, onEdit, onDelete }) => {
    
    const columns = useMemo(() => [
        {
            accessorKey: 'title',
            header: 'Report Title',
            cell: info => <span className='fw-bold'>{info.getValue()}</span>,
        },
        {
            accessorKey: 'template',
            header: 'Template',
            cell: info => <code>{info.getValue()}.jrxml</code>
        },
        {
            accessorKey: 'parameters',
            header: 'Parameters',
            cell: info => {
                const params = info.getValue();
                return Array.isArray(params) ? params.map((p, idx) => (
                    <Badge bg='info' key={idx} className='me-1 text-dark'>{p}</Badge>
                )) : null;
            }
        },
        {
            id: 'actions',
            header: () => <div className='text-center'>Actions</div>,
            cell: info => (
                <div className="text-center">
                    <FaEdit
                        className='fa-edit'
                        title='Edit'
                        data-placement='bottom'
                        data-toggle='tooltip'
                        onClick={() => onEdit(info.row.original.id)}
                    />

                    <FaTimes
                        className='fa-times'
                        title='Delete'
                        data-placement='bottom'
                        data-toggle='tooltip'
                        onClick={() => onDelete(info.row.original.id)}
                    />
                </div>
            )
        }
    ], [onEdit, onDelete]);

    const table = useReactTable({
        data: reports,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

  return (
    <div className="table-responsive mt-4">
        <Table hover striped className='align-middle'>
            <thead className='table-dark'>
                {table.getHeaderGroups().map(headerGroup => (
                    <tr key={headerGroup.id}>
                        {headerGroup.headers.map(header => (
                            <th key={header.id}>
                                {flexRender(header.column.columnDef.header, header.getContext())}
                            </th>
                        ))}
                    </tr>
                ))}
            </thead>
            <tbody>
                {table.getRowModel().rows.length > 0 ?(
                    table.getRowModel().rows.map(row => (
                        <tr key={row.id}>
                            {row.getVisibleCells().map(cell => (
                                <td key={cell.id}>
                                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                </td>
                            ))}
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan={columns.length} className='text-center py-4 text-muted'>
                            No report configurations found.
                        </td>
                    </tr>
                )}
            </tbody>
        </Table>
    </div>
  )
}

export default ReportsTable